import React from 'react';

import './NonCoveredShares.scss';
import config from 'src/config/config';
import { formatShares } from 'src/utils/utils';
import words from 'src/utils/words';

export interface NonCoveredSharesProps {
  coveredShares?: number;
  uncoveredShares?: number;
  isAutomatic?: boolean;
  isSweep?: boolean;
}

const NonCoveredShares: React.FC<NonCoveredSharesProps> = ({
  coveredShares = 0,
  uncoveredShares = 0,
  isAutomatic = false,
  isSweep = false,
}) => (
  <div className="exclude non-covered-shares">
    This fund contains{' '}
    <span className="exclude uncovered-shares">
      {formatShares(uncoveredShares, 'Noncovered', words.Share)}
    </span>{' '}
    and
    <span className="exclude covered-shares">
      {' '}
      {formatShares(coveredShares, 'Covered', words.Share)}.
    </span>{' '}
    Noncovered shares (shares purchased before 2012) will be redeemed before{' '}
    {isAutomatic && (
      <>
        covered shares regardless of the cost basis method selected.
        {isSweep && (
          <>
            {' '}
            The Specific Lot Identification (SLID) method may not be used for
            systematic transactions.
          </>
        )}
      </>
    )}
    {!isAutomatic && (
      <>
        covered shares regardless of the cost basis method selected, unless you{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          contact us
        </a>{' '}
        to request a redemption using the Specific Lot Identification (SLID)
        method.
      </>
    )}{' '}
    Once all noncovered shares are redeemed, covered shares will be redeemed
    using the cost basis method selected for the account.
  </div>
);

export default NonCoveredShares;
